var $ = require('jquery');
var _ = require('../core/lodash');

module.exports = function () {
    var uniqueId = _.uniqueId('mask_layer_');
    var showCount = 0;
    var showFlag;
    var $maskLayer;
    function createMaskLayer() {
        if(!document.getElementById(uniqueId)){
            $maskLayer = $('<div id="' +uniqueId+'"><div class="mask-transparent"></div><div class="mask-content"></div></div>');
            $maskLayer.children().hide();
            showFlag = false;
            $('body').append($maskLayer);
        }
    }
    return {
        getMaskLayer:function () {
            createMaskLayer();
            return $maskLayer;
        },
        getMaskContent:function () {
            createMaskLayer();
            return $maskLayer.find('.mask-content');
        },
        show:function () {
            createMaskLayer();
            showCount++;
            if( !showFlag ){
                showFlag = true;
                $maskLayer.find('.mask-transparent').show();
                $maskLayer.find('.mask-content').css({
                    marginTop:function () {
                        var height = $(this).height()/2;
                        return '-'+(height<40?40:height)+'px';
                    },
                    marginLeft:function () {
                        var width = $(this).width()/2;
                        return '-'+(width<50?50:width)+'px';
                    }
                }).fadeIn();
            }
        },
        //调用n次show必须调用n次hide才能隐藏maskLayer
        hide:function (callback) {
            if(showCount>0){
                showCount--;
                if(document.getElementById(uniqueId) && showCount === 0){
                    $maskLayer.find('.mask-transparent').hide();
                    $maskLayer.find('.mask-content').fadeOut(function () {
                        $maskLayer.remove();
                        $maskLayer = null;
                        callback && callback();
                    });
                    showFlag = false;
                }else{
                    callback && callback();
                }
            }
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/components/mask-layer.js
// module id = 80
// module chunks = 0